

























































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import QuestionnaireExplorer from "@/components/QuestionnaireExplorer.vue";
import EngineExplorer from "@/components/EngineExplorer.vue";
import CoverExplorer from "@/components/CoverExplorer.vue";
import UserManagement from "@/components/UserManagement.vue";
import JobBoardManagement from "@/components/JobBoardManagement.vue";
import CreditsViewer from "@/components/CreditsViewer.vue";
import AdminMetadataUpdater from "@/components/AdminMetadataUpdater.vue";
import LocationExplorer from "@/components/LocationExplorer.vue";
import JobMetadataUpdater from "@/components/JobMetadataUpdater.vue";
import QuestionnaireSectActiv from "@/components/DeSiSectActiv/QuestionnaireSectActiv.vue";
import NeuroscienceEvaluation from "@/components/NeuroscienceEvaluation/NeuroscienceEvaluation.vue";
import SessionProjectEvaluation from "@/components/SessionProjectEvaluation.vue";
import DepouillementUpdater from "@/components/DepouillementUpdater.vue";
import PoidsEtEcartsUpdater from "@/components/PoidsEtEcartsUpdater.vue";
import EngineChecker from "@/components/EngineChecker.vue";
import Certificat_comments from "@/components/Certificat_comments.vue";
import JobMatchingEditor from "@/components/JobMatchingEditor.vue";
import SoftSkillsEditor from "@/components/SoftSkillsEditor.vue";
import AdminNormatifQuestionnaireExplorer from "@/components/AdminNormatifQuestionnaireExplorer.vue";
import { mapGetters } from "vuex";

import Normatif from "./OutilNormatif/Normatif.vue";

axios.defaults.baseURL = process.env.BASE_URL;

@Component({
  components: {
    QuestionnaireExplorer,
    EngineExplorer,
    UserManagement,
    CreditsViewer,
    AdminMetadataUpdater,
    JobMetadataUpdater,
    LocationExplorer,
    JobBoardManagement,
    CoverExplorer,
    QuestionnaireSectActiv,
    EngineChecker,
    NeuroscienceEvaluation,
    SessionProjectEvaluation,
    Normatif,
    DepouillementUpdater,
    PoidsEtEcartsUpdater,
    JobMatchingEditor,
    Certificat_comments,
    SoftSkillsEditor,
    AdminNormatifQuestionnaireExplorer
 },
  computed: mapGetters(["getUser"])
})
export default class DashboardAdmin extends Vue { }
